import { createAction, props } from "@ngrx/store";

import {
    CityEntry,
    ContinentEntry,
    CountryEntry,
    ShopLocationsCountryMode,
    ShopLocationsDefaultMode,
} from "./shop-locations.state";

export const generateCountriesFromShops = createAction(
    "[Shop Locations] Generate countries list from shops",
);

export const setContinents = createAction(
    "[Shop Locations] Set continents",
    props<{ continents: ContinentEntry[] }>(),
);

export const setCountries = createAction(
    "[Shop Locations] Set countries",
    props<{ countries: CountryEntry[] }>(),
);

export const setCurrentCountry = createAction(
    "[Shop Locations] Set current country",
    props<{
        countryCode: string;
        pageMode: ShopLocationsCountryMode | ShopLocationsDefaultMode;
    }>(),
);

export const setCities = createAction(
    "[Shop Locations] Set cities",
    props<{ cities: CityEntry[] }>(),
);

export const setCurrentCity = createAction(
    "[Shop Locations] Set current city",
    props<{
        city: CityEntry;
    }>(),
);

export const updateShopLocator = createAction(
    "[Shop Locations] Update Shop Locator",
);

export const navigateToCountryPage = createAction(
    "[Shop Locations] Navigate to country page",
    props<{
        country: CountryEntry;
    }>(),
);

export const navigateToCityPage = createAction(
    "[Shop Locations] Navigate to city page",
    props<{
        city: CityEntry;
    }>(),
);

export const toggleContinentAndCloseOthers = createAction(
    "[Shop Locations] Toggle continent and close others",
    props<{
        continentName: string;
    }>(),
);

export const openCurrentCountryContinentAndCloseOthers = createAction(
    "[Shop Locations] Open current country continent and close others",
    props<{
        continentName: string;
    }>(),
);
